'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    console.error('Global error boundary caught an error:', error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased">
        <main className="mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 py-16 text-center">
          <h1 className="mb-3 text-3xl font-bold text-slate-900">
            Unexpected application error
          </h1>
          <p className="mb-8 text-slate-600">
            An unrecoverable error occurred. Please retry.
          </p>
          <button
            type="button"
            onClick={reset}
            className="rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-700"
          >
            Retry
          </button>
        </main>
      </body>
    </html>
  );
}
